import { Component, AfterViewInit, ViewContainerRef, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { GridApi, ICellEditorParams } from 'ag-grid-community';
import { TicketService } from '../../../tickets/ticket.service';
import { DriverReference } from '../driver-reference';

@Component({
  selector: 'driver-reference-cell',
  templateUrl: './driver-reference-cell.component.html',
  styleUrls: ['./driver-reference-cell.component.scss'],
  providers: [TicketService],
})
export class DriverReferenceCell implements ICellEditorAngularComp, AfterViewInit {
  params!: ICellEditorParams;
  gridApi!: GridApi;
  reference!: DriverReference;
  value = '';

  @ViewChild('driverReferenceInput', { read: ViewContainerRef }) jobReferenceInput: any;

  constructor(
    private ticketService: TicketService,
  ) { }

  agInit(params: ICellEditorParams) {
    this.params = params;
    this.gridApi = params.api;
  }

  ngAfterViewInit(): void { }

  getValue() {
    if (this.reference) {
      return this.reference.driverName;
    }

    const cell = this.gridApi.getFocusedCell();
    const row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);

    return row && row.data.driverName ? row.data.driverName : '';
  }

  isCancelBeforeStart?(): boolean {
    return false;
  }

  isCancelAfterEnd?(): boolean {
    return false;
  }

  isPopup() {
    return true;
  }

  onReferenceClicked(reference: DriverReference): void {
    const cell = this.gridApi.getFocusedCell();
    const row = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);

    this.ticketService.updateFieldReference<DriverReference>(row.data.id, reference, 'driver').subscribe(ticket => {
      this.reference = reference;

      row.setData(ticket);

      this.gridApi.stopEditing();
    });
  }

  onReferenceClosed(): void {
    this.gridApi.stopEditing();
  }
}
